module.exports = __webpack_public_path__ + "static/media/leash.73e70c73.png";